import { Avatar, Typography, Stack, Button, Box } from '@mui/material';

import type { UserProfile } from '#packages/web/types/user-profile';
import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

export type SignedInUserProfilePageContentProps = {
  /**
   * The user's profile information.
   */
  userProfile: UserProfile;

  /**
   * Callback function when the sign out button is clicked.
   */
  onSignOutClick: () => void;
};

/**
 * A card component that displays the signed-in user's profile information.
 * Shows the user's avatar, full name, and email address.
 */
export const SignedInUserProfilePageContent = ({
  userProfile,
  onSignOutClick,
}: SignedInUserProfilePageContentProps) => (
  <CenteredLayout horizontal vertical>
    <Stack spacing={5}>
      <Stack spacing={1}>
        <Stack spacing={2} alignItems="center">
          <Avatar alt={userProfile.fullName} src={userProfile.avatarUrl}>
            {userProfile.avatarText}
          </Avatar>

          <Stack spacing={0.5} alignItems="center">
            <Typography variant="h5">{userProfile.fullName}</Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {userProfile.email}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
        <Button variant="outlined" color="warning" onClick={onSignOutClick}>
          Sign Out
        </Button>
      </Box>
    </Stack>
  </CenteredLayout>
);
